exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.async-component-error{display:flex;height:100%;align-items:center;justify-content:center\n}\n.async-component-error .btn{margin:.5em;padding:.5em 2em\n}", ""]);

// exports
